import React from "react";

export default function PageNotFound() {
  return (
    <div className="page-not-found">
      <h1>Page Not Found</h1>
    </div>
  );
}
